export default __webpack_public_path__ + "static/media/spaceStation4.11b08c9e.webp";